<!-- src/components/layout/Footer.vue -->
<template>
  <footer :class="[computedClass.footer, { 'ui-footer--hidden': isFooterHidden }]">
    <div class="ui-footer__inner container">
      <p>© {{ new Date().getFullYear() }} Expected Maximum. All rights reserved.</p>

      <div class="ui-footer__controls">
        <button
          :class="computedClass.button"
          @click="toggleDarkMode"
        >
          Switch to {{ isDark ? 'Light' : 'Dark' }} Mode
        </button>

        <select
          v-model="selectedTheme"
          :class="computedClass.select"
          :disabled="isThemeLocked"
          @change="updateTheme"
        >
          <option
            v-for="theme in availableThemes"
            :key="theme"
            :value="theme"
          >
            {{ theme.charAt(0).toUpperCase() + theme.slice(1) }} Theme
          </option>
        </select>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue';
import { useTheme } from '@/composables/useTheme';

// Use theme composable
const { 
  isDark, 
  toggleDarkMode, 
  setTheme, 
  availableThemes, 
  computedClass, 
  currentTheme,
  isThemeLocked
} = useTheme();

const isFooterHidden = true;

// Bind selected theme
const selectedTheme = ref(currentTheme.value);

// Function to update the theme from select dropdown
const updateTheme = () => {
  setTheme(selectedTheme.value);
};
</script>
